import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Charactersfsk() {
  return (
    <div className="character_fsk p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="text-center">
            <h2>
              <span>Characters</span>
            </h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <div className="characters_main">
              <div className="character_box">
                <div className="character_img">
                  <StaticImage
                    src="../../../images/case-studies/fsk/adam.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["png"]}
                    width={242}
                    height={250}
                  />
                </div>
                <div className="character_content">
                  <h4>Adam</h4>
                </div>
              </div>
              <div className="character_box">
                <div className="character_img">
                  <StaticImage
                    src="../../../images/case-studies/fsk/burg.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["png"]}
                    width={242}
                    height={250}
                  />
                </div>
                <div className="character_content">
                  <h4>Burg</h4>
                </div>
              </div>
              <div className="character_box">
                <div className="character_img">
                  <StaticImage
                    src="../../../images/case-studies/fsk/dunk.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["png"]}
                    width={242}
                    height={250}
                  />
                </div>
                <div className="character_content">
                  <h4>Dunk</h4>
                </div>
              </div>
              <div className="character_box">
                <div className="character_img">
                  <StaticImage
                    src="../../../images/case-studies/fsk/julie.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["png"]}
                    width={242}
                    height={250}
                  />
                </div>
                <div className="character_content">
                  <h4>Julie</h4>
                </div>
              </div>
              <div className="character_box">
                <div className="character_img">
                  <StaticImage
                    src="../../../images/case-studies/fsk/krystal.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["png"]}
                    width={242}
                    height={250}
                  />
                </div>
                <div className="character_content">
                  <h4>Krystal</h4>
                </div>
              </div>
              <div className="character_box">
                <div className="character_img">
                  <StaticImage
                    src="../../../images/case-studies/fsk/travis.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["png"]}
                    width={242}
                    height={250}
                  />
                </div>
                <div className="character_content">
                  <h4>Travis</h4>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Charactersfsk;
